"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryCatch = void 0;
function tryCatch(lazyFn, fallback) {
    let reason;
    try {
        const result = lazyFn();
        if (result != null) {
            return result;
        }
    }
    catch (err) {
        reason = err;
    }
    return returnFallback(fallback, reason);
}
exports.tryCatch = tryCatch;
function returnFallback(fallback, reason) {
    return typeof fallback === "function" ? fallback(reason) : fallback;
}
//# sourceMappingURL=try-catch.js.map